import { StateCreator } from "zustand";
import PublicPortalState from "@publicPortal/utils/InitialState";
import { PlanningAppealsSearchState } from "@publicPortal/pages/search/PlanningAppeal/PlanningAppealsSearchState";

const { initialSearchState: paInitialState, initialFilterState: paInitialFilter } = PublicPortalState.planningAppealInitialSearchState();

export interface PlanningAppealsSearchSlice {
    planningAppealsSearch: PlanningAppealsSearchState;
    setPlanningAppealsSearch: (state: PlanningAppealsSearchState) => void;
    updatePlanningAppealsSearch: (partialState: Partial<PlanningAppealsSearchState>) => void;
    updatePlanningAppealsFilter: (partialFilter: Partial<PlanningAppealsSearchState["filter"]>) => void;
    resetPlanningAppealsFilter: () => void;
}

export const createPlanningAppealsSearchSlice: StateCreator<PlanningAppealsSearchSlice, [], [], PlanningAppealsSearchSlice> = (set) => ({
    planningAppealsSearch: paInitialState,
    setPlanningAppealsSearch: (state) => set({ planningAppealsSearch: state }),
    updatePlanningAppealsSearch: (partialState) => set((state) => ({ planningAppealsSearch: { ...state.planningAppealsSearch, ...partialState } })),
    updatePlanningAppealsFilter: (partialFilter) =>
        set((state) => ({
            planningAppealsSearch: { ...state.planningAppealsSearch, filter: { ...state.planningAppealsSearch.filter, ...partialFilter } },
        })),
    resetPlanningAppealsFilter: () => set((state) => ({ planningAppealsSearch: { ...state.planningAppealsSearch, filter: { ...paInitialFilter } } })),
});

